/* Repairs accessibility-tree issues in app-rendered markup (Globo quick view links, Revy quantity-break radios). */
(() => {
  const quickViewSelector = 'a.open-quick-view:not([href])';
  const tierSelector = 'input[name="rbu-qb-tier"]';
  const tierContainer = '.rbu-qb-tier-container';

  const fixQuickView = link => {
    if (link.dataset.acoA11y) return;
    link.dataset.acoA11y = '1';
    if (link.hasAttribute('role') || link.hasAttribute('tabindex')) return;
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
    link.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      link.click();
    });
  };

  const tierText = input => {
    const box = input.closest(tierContainer);
    if (!box) return '';
    const header = box.querySelector('.rbu-qb-tier-header') || box;
    const parts = [];
    const walker = document.createTreeWalker(header, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const text = walker.currentNode.nodeValue.trim();
      if (text) parts.push(text);
    }
    return parts.join(' ').replace(/\s+/g, ' ').slice(0, 120);
  };

  const fixTier = input => {
    if ((input.labels && input.labels.length) || input.hasAttribute('aria-labelledby')) return;
    const text = tierText(input);
    if (text && input.getAttribute('aria-label') !== text) input.setAttribute('aria-label', text);
  };

  const repair = root => {
    if (!root || !root.querySelectorAll) return;
    if (root.matches(quickViewSelector)) fixQuickView(root);
    if (root.matches(tierSelector)) fixTier(root);
    root.querySelectorAll(quickViewSelector).forEach(fixQuickView);
    root.querySelectorAll(tierSelector).forEach(fixTier);
  };

  const queue = new Set();
  let timer = 0;
  const flush = () => {
    timer = 0;
    const roots = [...queue];
    queue.clear();
    roots.forEach(root => { if (root.isConnected) repair(root); });
  };

  const enqueue = node => {
    const element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return;
    queue.add(element.closest(tierContainer) || element);
    if (!timer) timer = setTimeout(flush, 60);
  };

  repair(document.body);
  new MutationObserver(records => {
    for (const record of records) record.addedNodes.forEach(enqueue);
  }).observe(document.body, { childList: true, subtree: true });
})();